import moment from 'moment';
import ApiService from 'services/ApiService';
import { Utils } from '../../../utils/UtilsDefault';

export class Validations {
  static composeValidators =
    (...validators: Array<any>) =>
      (value: string): any => {
        validators = validators.filter(data => data != null);
        return validators.reduce(
          (error, validator) => error || validator(value),
          undefined,
        );
      };

  static validateEmailIsRegistered = async (email: string): Promise<string> => {
    try {
      const response = await ApiService.verificarSeEmailExiste.getEmail(email);
      if (response) {
        return 'Email já cadastrado';
      }
    } catch (error) {
      return undefined;
    }

    return undefined;
  };

  static cpfValidation(value: string): boolean {
    if (!value) return null;
    return Utils.validaCPF(Utils.retirarFormatacao(value));
  }

  static checkPasswordValidation(value: string): string {
    if (!/[A-Z]/.test(value)) {
      return 'A senha tem que conter ao menos uma letra maiúscula'
    }
    if (!/[a-z]/.test(value)) {
      return 'A senha tem que conter ao menos uma letra minúscula'
    }
    
    if (!/\d/.test(value)) {
      return 'A senha tem que conter ao menos um número';
    }

    if (!/[^A-Za-z0-9&@'"]/.test(value)) {
      return `A senha tem que conter ao menos um caractere especial (exceto & @ ' (aspas simples) e " (aspas duplas))`;
    }

    // if (/^(?=.*\d)(?=.*[a-zA-Z])(?!.*\s).*$/.test(value)) {
    //   return 'A senha tem que conter letras e números'
    // }

    return undefined
  }

  static required = (value: string): string =>
    value ? undefined : 'Este campo é obrigatório';
  // eslint-disable-next-line
  static mustBeNumber = (value: number): string =>
    Number.isNaN(value) ? 'Somente número' : undefined;

  static minAge =
    (min: number) =>
      (value: string): string => {
        // eslint-disable-next-line
        const informedAge = Utils.calculateAge(value);
        return Number.isNaN(informedAge) || informedAge >= min
          ? undefined
          : `Idade tem que ser maior que ${min}`
      };

  static maxAge =
    (max: number) =>
      (value: string): string => {
        // eslint-disable-next-line
        const informedAge = Utils.calculateAge(value);
        return Number.isNaN(informedAge) || informedAge < max
          ? undefined
          : `Idade tem que ser menor que ${max}`;
      };

  static minCharacteres =
    (min: number) =>
      (value: string): string => {
        return value.length >= min
          ? undefined
          : `Senha deve conter no minímo ${min} caracteres`;
      };

  static noSpetialChar = (value: string): string => {
    const test =
      /[^A-Za-z\d!$@*&.ÁÈôÇáèÒçÂËòâëÀàðÕÅõåÍÖÃíöãÎÄîÚäÌúìÛæÏûïÙÉùéÓÊóêÔ]/gm.test(
        value,
      );
    return !test ? undefined : `Caracteres aceitos:  & $ ! * .`;
  };


  static validateDataNascimentoMinMax =
    (ageMin: number, ageMax: number) =>
      (value: string): string => {
        const informedAge = Utils.calculateAge(value);
        if (informedAge < ageMin || ageMax < informedAge) {
          return `Data de nascimento não está entre ${ageMin} anos e ${ageMax} anos`;
        }
        if (informedAge > 130 || !informedAge) {
          return 'Data Inválida.';
        }
        return undefined;
      };

  static validateEqualPassword =
    (password: string) =>
      (newPassword: string): string => {
        return password === newPassword
          ? undefined
          : 'Confirmação da senha deve ser igual ao do campo Senha';
      };

  static validateCPFUnique =
    (
      values: {
        grupos: [
          {
            pax: [
              {
                Documento: string;
              },
            ];
          },
        ];
      },
      indexDadosConsulta: number,
      indexDadosHospedes: number,
      cpfList: Array<any>,
    ) =>
      (value: string): string => {
        let isUnique = true;
        const { grupos } = values;
        const cpfAtual = value;
        let listaCpf = [];
        if (cpfList && cpfList.length > 0) {
          listaCpf = JSON.parse(JSON.stringify(cpfList));
        }
        grupos.forEach((d, i) => {
          d.pax.forEach((pax, iPax) => {
            if (i === indexDadosConsulta && iPax !== indexDadosHospedes) {
              listaCpf.push(pax.Documento);
            }
          });
        });

        listaCpf.forEach(cpf => {
          if (Utils.somenteNumeros(cpf) === Utils.somenteNumeros(cpfAtual)) {
            isUnique = false;
          }
        });
        return !isUnique ? 'CPF já utilizado em hospede anterior' : undefined;
      };

  static validateCPFUniqueSimple =
    (listaCpf: Array<any>) =>
      (value: string): string => {
        let isUnique = true;
        const cpfAtual = value;

        listaCpf.forEach(cpf => {
          if (Utils.somenteNumeros(cpf) === Utils.somenteNumeros(cpfAtual)) {
            isUnique = false;
          }
        });

        return !isUnique ? 'CPF dever ser único' : undefined;
      };

  static validateCPF = (Documento: string): string =>
    !Utils.validaCPF(Documento) ? 'Documento é obrigatório' : undefined;

  static validateEmail = (email: string): string =>
    !Utils.validateEmail(email) ? 'Email inválido' : undefined;

  static validateTelefone = (telefone: string): string =>
    !Utils.validaTelefone(telefone) ? 'Número de telefone inválido' : undefined;

  static validadePromo = (cupomValido: string): string =>
    cupomValido ? 'Cupom Inválido' : undefined;

  static minCurrencyValue =
    (min: string) =>
      (value: string): string => {
        return Utils.moedaParaNumero(value) >= parseFloat(min)
          ? undefined
          : `Valor minimo é de R$ ${Utils.converteEmMoeda(min)}`;
      };

  static validateDataNascimento =
    (age: number) =>
      (value: string): string => {
        const informedAge = Utils.calculateAge(value);
        if (informedAge < age) {
          return `Data de nascimento é menor que ${age} anos para Adultos`;
        }
        if (informedAge > 130 || !informedAge) {
          return 'Data Inválida.';
        }
        return undefined;
      };

  static validateDataNascimentoCrianca =
    (type: string, age: string, ageMaxInf?: number) =>
      (dtNascimento: string): string => {
        if (type === 'CHD') {
          if (!Utils.checkDateValidation(dtNascimento)) {
            return 'Data de nascimento é obrigatório';
          }
          if (Utils.calculateAge(dtNascimento) !== parseInt(age)) {
            return 'Data de nascimento não condiz com a idade informada';
          }
          // if (
          //   Utils.calculateAge(dtNascimento) < 2 ||
          //   Utils.calculateAge(dtNascimento) > 11
          // ) {
          //   return 'Idade inválida para criança.';
          // }
        }

        if (type === 'INF') {
          if (!Utils.checkDateValidation(dtNascimento)) {
            return 'Data de nascimento é obrigatório';
          }
          if (Utils.calculateAge(dtNascimento) >= ageMaxInf) {
            return 'Data de nascimento é maior que 23 meses para Bebês';
          }
        }
        return undefined;
      };

  static validateDataNascimentoCriancaFlight =
    (type: string, age: string, ageMaxInf?: number) =>
      (dtNascimento: string): string => {
        if (type === 'CHD') {
          if (!Utils.checkDateValidation(dtNascimento)) {
            return 'Data de nascimento é obrigatório';
          }
          if (
            Utils.calculateAge(dtNascimento) < 2 ||
            Utils.calculateAge(dtNascimento) > 11
          ) {
            return 'Idade inválida para criança.';
          }
        }

        if (type === 'ADT') {
          if (!Utils.checkDateValidation(dtNascimento)) {
            return 'Data de nascimento é obrigatório';
          }
          if (Utils.calculateAge(dtNascimento) < 12) {
            return 'Idade inválida.';
          }
        }


        if (type === 'INF') {
          if (!Utils.checkDateValidation(dtNascimento)) {
            return 'Data de nascimento é obrigatório';
          }
          if (Utils.calculateAge(dtNascimento) >= ageMaxInf) {
            return 'Data de nascimento é maior que 23 meses para Bebês';
          }
        }
        return undefined;
      };

  static validateDataNascimentoCriancaPacote =
    (type: string, age: string, dataCheckIn: string) =>
      (dtNascimento: string): string => {
        if (type !== 'ADT') {
          if (!Utils.checkDateValidation(dtNascimento)) {
            return 'Data de nascimento é obrigatório';
          }
          const idade = Utils.getAge(
            Utils.converterParaDate(dtNascimento),
            Utils.converterStringParaDate(dataCheckIn),
          );

          if (idade > parseInt(age, 10)) {
            return 'Data de nascimento não condiz com a idade informada';
          }
        }
        return undefined;
      };

  static validaDataVencimento = (value: string): string => {
    if (value !== undefined && value.length === 5) {
      const separateDate = value.split('/');
      const mes = separateDate[0] ? separateDate[0] : null;
      const ano = separateDate[1] ? separateDate[1] : null;
      const anoCompleto = `20${ano}`;

      const data = moment(`${mes}-${anoCompleto}`, 'MM-YYYY').format();
      const hoje = moment().format();
      if (mes == null || Number(mes) > 12 || ano == null) {
        return 'Data invalida';
      }
      if (data < hoje) {
        return 'Cartão está Vencido, por favor informe um novo cartão';
      }
      return undefined;
    }
    return 'Data Invalida';
  };

  static validateCvv = (value: string): string => {
    if (value.length >= 3) {
      return undefined;
    }
    return 'Codigo Invalido';
  };

  static validateCvvAmex = (value: string): string => {
    if (value.length >= 4) {
      return undefined;
    }
    return 'Codigo Invalido';
  };

  static validateEmailConfirmation =
    (email: string) =>
      (value: string): string => {
        if (email !== value) {
          return 'Confirmação de e-mail é diferente do E-mail';
        }

        return undefined;
      };

  static validatePassword = (value: string): string => {
    if (value.length < 8) {
      return 'Sua senha deve conter no minímo 8 caracteres';
    }
    if (value.search(/\d/) === -1) {
      return 'Sua senha deve conter no minímo 1 número';
    }
    if (value.search(/[a-zA-Z]/) === -1) {
      return 'Sua senha deve conter no minímo 1 letra';
    }
    return undefined;
  };

  static validateCreditCard = (value: string): string => {
    if (/[^0-9-\s]+/.test(value)) return null;

    let nCheck = 0;
    let bEven = false;
    value = value.replace(/\D/g, '');

    for (let n = value.length - 1; n >= 0; n -= 1) {
      const cDigit = value.charAt(n);
      let nDigit = parseInt(cDigit, 10);
      // eslint-disable-next-line
      if (bEven && (nDigit *= 2) > 9) nDigit -= 9;

      nCheck += nDigit;
      bEven = !bEven;
    }
    if (nCheck % 10 !== 0) {
      return 'Cartão inválido, por favor verifique a numeração.';
    }
    return undefined;
  };

  static validateDate(date: string): string {
    if (!Utils.checkDateValidation(date)) {
      return 'Data de nascimento é obrigatório';
    }
    return undefined;
  }

  static validateDatePassport(date: string): string {
    if (!Utils.checkDateValidation(date)) {
      return 'Data de expiração obrigatória';
    }

    if (new Date() >= new Date(date.split('/').reverse().join('/'))) {
      return 'Data Expirada';
    }
    return undefined;
  }

  static validateDateRG(date: string): string {
    if (!Utils.checkDateValidation(date)) {
      return 'Data de emissão obrigatória';
    }

    if (new Date() <= new Date(date.split('/').reverse().join('/'))) {
      return 'Data Expirada';
    }
    return undefined;
  }

  static validateIsBannedWords(string: string): string {
    const bannedWords = ['test', 'teste'];

    let value = 0;

    bannedWords.forEach(word => {
      value += string.toLocaleLowerCase().includes(word.toLocaleLowerCase()) ? 1 : 0;
    });

    if (value > 0) {
      return `Não é permitido utilzar paralvras como: ${bannedWords.join()}`;
    }
    return undefined;
  }
}
